import React, { ReactNode, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { dispatchItemsList } from '../functions';
import { transformData } from '../gantTransformData';
import { useSettingsAppliedToRedux } from '../hooks/useSettingsAppliedToRedux';
import { useValueSelector } from '../hooks/useValueSelector';
import { RootState } from '../store';
import { ItemType, LoaderDataType, ScheduleItemType } from '../types';
import { useRouting } from './routingProvider';
import { useApplyUrlParamsToRedux } from './useApplyUrlParamsToRedux';

interface WithInitialUrlParamsProps {
    children: ReactNode;
    authorId: string;
    onFinish?: () => void;
}
export const WithInitialUrlParams: React.FC<WithInitialUrlParamsProps> = ({ authorId, children, onFinish }) => {
    const itemsFromServer = useValueSelector<RootState, LoaderDataType<ScheduleItemType>>(
        (state) => state.gantLoader.dataScheduleItemFromServer,
    );
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);

    const [isReady, setIsReady] = useState(false);
    const { getUrlPath } = useRouting();

    const isSettingsApplied = useSettingsAppliedToRedux(authorId);
    const isEverythingLoaded = useApplyUrlParamsToRedux(isReady && isSettingsApplied);

    useEffect(() => {
        const isGantAlreadyLoaded =
            (itemsFromServer.connectionId && itemsFromServer.rows.length === 0) ||
            (itemsFromServer.rows.length > 0 && itemsList.length > 0);

        const isGantPage = getUrlPath().endsWith('timeline');

        if (!isGantAlreadyLoaded && !isGantPage) {
            dispatchItemsList(transformData(itemsFromServer.rows));
        } else {
            // is ready to setup redux store
            setTimeout(() => {
                setIsReady(true);
            }, 500);
        }
    }, [itemsFromServer]);

    useEffect(() => {
        if (onFinish) {
            onFinish();
        }
    }, [isEverythingLoaded]);

    if (!authorId) {
        return null;
    }
    return <>{children}</>;
};
